export default "__VITE_ASSET__ef5f9bb9__"